import { request } from "@/utils/request";

export const getDictionary = (params) => {
  return request({
    url: "/api/lingxi-system/dict-biz/dictionary",
    method: "get",
    params,
  });
};
